import { render, staticRenderFns } from "./ModalTypographySettings.vue?vue&type=template&id=9bcfa174&scoped=true"
import script from "./ModalTypographySettings.vue?vue&type=script&lang=js"
export * from "./ModalTypographySettings.vue?vue&type=script&lang=js"
import style0 from "./ModalTypographySettings.vue?vue&type=style&index=0&id=9bcfa174&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcfa174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bcfa174')) {
      api.createRecord('9bcfa174', component.options)
    } else {
      api.reload('9bcfa174', component.options)
    }
    module.hot.accept("./ModalTypographySettings.vue?vue&type=template&id=9bcfa174&scoped=true", function () {
      api.rerender('9bcfa174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalTypographySettings.vue"
export default component.exports